module.exports = __webpack_public_path__ + "static/media/iconTransportActive.2586eef6.svg";